import {toast as hotToast} from 'react-hot-toast';

export const toast = (text: string, color?: string, duration?: number) =>
  hotToast(text, {
    duration: duration || 4000,
    position: 'bottom-center',
    style: {
      color: '#fff',
      backgroundColor: color || 'rgba(0, 0, 0, 0.85)',
      fontSize: '14px',
      padding: '13px 24px',
      letterSpacing: '0.25px',
      textAlign: 'center'
    }
  });
